"use client";

import { Button, HStack, Stack, Text } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { iconSizePresets } from "@/shared/config/iconSizePresets";

type BacklogToolbarProps = {
  isSelectVisibleDisabled: boolean;
  onSelectVisible: () => void;
  selectedCount: number;
  visibleCount: number;
};

export default function BacklogToolbar({
  isSelectVisibleDisabled,
  onSelectVisible,
  selectedCount,
  visibleCount,
}: BacklogToolbarProps) {
  const visibleLabel =
    visibleCount === 1 ? "1 visible source" : `${visibleCount} visible sources`;
  const selectedLabel =
    selectedCount === 1 ? "1 selected" : `${selectedCount} selected`;
  const actionTitle =
    visibleCount > 0
      ? "Select visible source material"
      : "No visible source material to select";

  return (
    <HStack
      minH={{ base: "14", md: "16" }}
      align="center"
      justify="space-between"
      gap={{ base: "3", md: "4" }}
      bg="moveon.surface.toolbarBg"
      borderWidth="1"
      borderColor="moveon.surface.border"
      borderRadius="md"
      px={{ base: "3", md: "4" }}
      py={{ base: "3", md: "2.5" }}
    >
      <HStack gap="3" minW="0" flex="1">
        <Button
          variant="outline"
          onClick={onSelectVisible}
          title={actionTitle}
          aria-label="Select visible source material"
          borderColor="moveon.surface.interactiveBorder"
          color="moveon.surface.fg"
          flexShrink="0"
          h="10"
          w="10"
          minW="10"
          p="0"
          disabled={isSelectVisibleDisabled}
          _hover={{
            bg: "moveon.surface.elevatedBg",
            borderColor: "moveon.selection.hoverBorder",
          }}
        >
          <GenericIcon
            icon="select"
            size={iconSizePresets.actionButton}
            visuallyInactive={isSelectVisibleDisabled}
            humanReadable="Select visible source material"
          />
        </Button>

        <Stack gap="0.5" minW={0}>
          <Text
            fontSize={{ base: "sm", md: "md" }}
            fontWeight="semibold"
            color="moveon.surface.fg"
            lineHeight="short"
          >
            Backlog archive
          </Text>
          <HStack gap="2" flexWrap="wrap">
            <Text fontSize="xs" color="moveon.text.muted" lineHeight="short">
              {visibleLabel}
            </Text>
            {selectedCount > 0 ? (
              <>
                <Text
                  aria-hidden="true"
                  fontSize="xs"
                  color="moveon.text.muted"
                  lineHeight="short"
                >
                  /
                </Text>
                <Text
                  fontSize="xs"
                  color="moveon.text.muted"
                  lineHeight="short"
                >
                  {selectedLabel}
                </Text>
              </>
            ) : null}
          </HStack>
        </Stack>
      </HStack>
    </HStack>
  );
}
